// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.single-order-page {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f6f9fc;
  }
  
  .order-card {
    width: 100%; /* Set the width to 80% of the screen */
    max-width: 600px; /* Add max-width to limit the container size on larger screens */
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    padding: 24px;
  }
  
  .order-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }
  
  .order-heading {
    font-size: 24px;
    font-weight: bold;
    color: #007bff;
  }
  
  .order-status {
    font-size: 16px;
    color: #007bff; /* Change color to match the header */
  }
  
  .order-detail {
    font-size: 16px;
    margin-bottom: 8px;
    color: #333;
  }
  
  .requirements-section {
    margin-top: 16px;
  }
  
  .requirements-section h4 {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    margin-bottom: 8px;
  }
  
  .requirements-text {
    font-size: 16px;
    color: #555;
  }
  
  .order-actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
  }
  
  .cancel-btn,
  .complete-btn {
    padding: 8px 16px;
    margin-left: 8px;
    font-size: 16px;
    font-weight: bold;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .cancel-btn {
    background-color: #dc3545;
    color: #fff;
  }
  
  .complete-btn {
    background-color: #28a745;
    color: #fff;
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/main/single_order/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,WAAW,EAAE,uCAAuC;IACpD,gBAAgB,EAAE,gEAAgE;IAClF,sBAAsB;IACtB,kBAAkB;IAClB,uCAAuC;IACvC,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,cAAc,EAAE,qCAAqC;EACvD;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;;IAEE,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb","sourcesContent":[".single-order-page {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100vh;\r\n    background-color: #f6f9fc;\r\n  }\r\n  \r\n  .order-card {\r\n    width: 100%; /* Set the width to 80% of the screen */\r\n    max-width: 600px; /* Add max-width to limit the container size on larger screens */\r\n    background-color: #fff;\r\n    border-radius: 8px;\r\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);\r\n    padding: 24px;\r\n  }\r\n  \r\n  .order-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 16px;\r\n  }\r\n  \r\n  .order-heading {\r\n    font-size: 24px;\r\n    font-weight: bold;\r\n    color: #007bff;\r\n  }\r\n  \r\n  .order-status {\r\n    font-size: 16px;\r\n    color: #007bff; /* Change color to match the header */\r\n  }\r\n  \r\n  .order-detail {\r\n    font-size: 16px;\r\n    margin-bottom: 8px;\r\n    color: #333;\r\n  }\r\n  \r\n  .requirements-section {\r\n    margin-top: 16px;\r\n  }\r\n  \r\n  .requirements-section h4 {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    color: #333;\r\n    margin-bottom: 8px;\r\n  }\r\n  \r\n  .requirements-text {\r\n    font-size: 16px;\r\n    color: #555;\r\n  }\r\n  \r\n  .order-actions {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    margin-top: 16px;\r\n  }\r\n  \r\n  .cancel-btn,\r\n  .complete-btn {\r\n    padding: 8px 16px;\r\n    margin-left: 8px;\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .cancel-btn {\r\n    background-color: #dc3545;\r\n    color: #fff;\r\n  }\r\n  \r\n  .complete-btn {\r\n    background-color: #28a745;\r\n    color: #fff;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
